import { isObject } from 'lodash';

export interface Waypoint {
  x: number;
  y: number;
  z: number;
  rx: number;
  ry: number;
  rz: number;
}

export type QNear = [number, number, number, number, number, number];

type URBaseArrayTypes = boolean | number | Waypoint;
type URBaseTypes = string | URBaseArrayTypes;
export type URVariable =
  | URBaseTypes
  | URBaseArrayTypes[]
  | URBaseArrayTypes[][];

const isWaypoint = (obj?: unknown): obj is Waypoint => {
  if (obj) {
    const keys = Object.keys(obj);
    return (
      keys.length === 6 &&
      keys.includes('x') &&
      keys.includes('y') &&
      keys.includes('z') &&
      keys.includes('rx') &&
      keys.includes('ry') &&
      keys.includes('rz')
    );
  }

  return false;
};

const orderWaypoint = (wp: Waypoint): Waypoint => {
  const PRECISION = 5;
  const { x, y, z, rx, ry, rz } = wp;
  return {
    x: parseFloat(x.toFixed(PRECISION)),
    y: parseFloat(y.toFixed(PRECISION)),
    z: parseFloat(z.toFixed(PRECISION)),
    rx: parseFloat(rx.toFixed(PRECISION)),
    ry: parseFloat(ry.toFixed(PRECISION)),
    rz: parseFloat(rz.toFixed(PRECISION)),
  };
};

const stringifyURVariable = (
  variable: URVariable | undefined
): string | undefined => {
  if (typeof variable !== 'object') {
    return `${variable}`;
  } else if (Array.isArray(variable)) {
    const arrayTypeVariable = variable as URBaseArrayTypes[];
    return `[ ${arrayTypeVariable
      .map((o: URBaseArrayTypes) => stringifyURVariable(o))
      .join(', ')} ]`;
  } else if (isObject(variable)) {
    let obj: Record<string, unknown> | Waypoint = variable as unknown as Record<
      string,
      unknown
    >;
    if (isWaypoint(obj)) {
      obj = orderWaypoint(obj);
      const props = Object.keys(obj)
        .map((key) => {
          const objectValue = (obj as Record<string, unknown>)[key] as Waypoint;
          return `${key}: ${stringifyURVariable(objectValue)}`;
        })
        .join(', ');
      return `{ ${props} }`;
    }
  }
};

export { orderWaypoint, stringifyURVariable };
